import { render, staticRenderFns } from "./DeckTemplate.vue?vue&type=template&id=234c6d82&scoped=true&"
import script from "./DeckTemplate.vue?vue&type=script&lang=js&"
export * from "./DeckTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DeckTemplate.vue?vue&type=style&index=0&id=234c6d82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c6d82",
  null
  
)

export default component.exports